<template>
    <div class="square-image-element media square-image-element__compensation">
        <div class="square-image-element__image">
            <ResponsiveImage
                v-if="customPriceImage"
                v-bind:image="customPriceImage"
            />
        </div>
        <div class="media-body">
            <div class="square-image-element__body">
                <button
                    class="square-image-element__title-container"
                    v-on:click="setCustomPriceSelected"
                >
                    <span class="square-image-element__button-container">
                        <span
                            class="donate-block__product-checkbox"
                            v-bind:class="{
                                'donate-block__product-checkbox--active':
                                    customPriceSelected,
                            }"
                        >
                            <span v-html="listCheckmarkIcon"></span>
                        </span>
                    </span>
                    <span>
                        <span class="square-image-element__title">
                            {{ customPriceText }}
                        </span>
                    </span>
                </button>
                <div class="custom-price-element">
                    <div class="custom-price-element__title">Anna summa</div>
                    <input
                        v-on:input="setCustomPrice"
                        aria-label="Anna summa"
                        inputmode="numeric"
                        v-imask="mask"
                        class="custom-price-element__input"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponsiveImage from '../../elements/responsive-image/ResponsiveImage';
import { IMaskDirective } from 'vue-imask';
import listCheckmarkIcon from '!raw-loader!./list-checkmark-icon.svg';

export default {
    props: ['custom-price-text', 'custom-price-image', 'custom-price-selected'],
    directives: {
        imask: IMaskDirective,
    },
    data: function () {
        return {
            mask: {
                mask: 'num €',
                lazy: false,
                blocks: {
                    num: {
                        mask: Number,
                    },
                },
            },
            listCheckmarkIcon,
        };
    },
    components: {
        ResponsiveImage,
    },
    methods: {
        setCustomPrice(event) {
            this.$parent.$emit(
                'setCustomPrice',
                parseInt(event.target.value, 10)
            );
        },
        setCustomPriceSelected() {
            this.$parent.$emit('enableCustomPrice');
        },
    },
};
</script>
